import {
  api_portalOfficeHospitalListing_medicalSubject,
  api_portalOfficeHospitalListing_responseFilter,
} from '@/init/swagger';
import NoImagePNG from '@/../public/no-image.png';
import { getPostCode } from '@/helpers/postCodeHelper';
import { getPrefName } from '@/data/prefectures';
import dayjs from '@/init/dayjs';
import { HospitalListingOutput } from '@/helpers/parseHospitalListings';
import { extractMatchingFilters } from '@/helpers/hospitalSearchFilterHelper';
import { HOSPITAL_SEARCH_FILTER } from '@/types/types';

type Props = {
  hospitalMedicalSubjects: api_portalOfficeHospitalListing_medicalSubject[];
  hospitalSearchFilters?: api_portalOfficeHospitalListing_responseFilter[];
  listingInfo: HospitalListingOutput;
  isPublicSearch: boolean;
};

export const useLogic = ({
  hospitalMedicalSubjects,
  hospitalSearchFilters,
  listingInfo,
  isPublicSearch,
}: Props) => {
  const thumbnailInfo = {
    image:
      listingInfo.portal_office_hospital_listing_image?.image1_url ||
      NoImagePNG.src,
    alt: listingInfo.portal_office_hospital_listing_image?.image1 || 'NO IMAGE',
  };

  const {
    portal_office: portalOfficeData,
    portal_office_hospital_listing_medical_subjects:
      portalOfficeMedicalSubjects,
    official_hp_url: hpUrl,
  } = listingInfo;

  const {
    post_code,
    pref = 0,
    city = '',
    area = '',
    building = '',
    tel_area,
    tel_city,
    tel_num,
    listing_updated_at,
  } = portalOfficeData;

  const postCode = post_code ? `〒${getPostCode(post_code)}` : '';
  const address = `${getPrefName(pref)}${city}${area}${building}`;
  const tel =
    tel_area && tel_city && tel_num ? `${tel_area}-${tel_city}-${tel_num}` : '';

  const medicalSubjects =
    portalOfficeMedicalSubjects
      .map(
        (portalItem) =>
          hospitalMedicalSubjects.find(
            (masterItem) => masterItem.id === portalItem.medical_subject_id,
          )?.label,
      )
      .join('・') || '';

  const updatedAt = listing_updated_at
    ? dayjs(listing_updated_at).format('YY.M.D')
    : '-';

  const appealPointFilters =
    hospitalSearchFilters?.filter(
      (filter) =>
        filter.category_id === HOSPITAL_SEARCH_FILTER.APPEAL_POINT_CATEGORY_ID,
    ) || [];

  const groupedAppealPoints = extractMatchingFilters(
    appealPointFilters,
    listingInfo.portal_office_hospital_listing_services,
  );

  const appealPoints = Object.values(groupedAppealPoints).flat();

  const portalOfficeInfo = {
    name: listingInfo.portal_office?.name,
    postCode,
    address,
    tel,
    medicalSubjects,
    hpUrl,
    updatedAt,
    appealPoints,
  };

  const cardHref = `/${isPublicSearch ? 'public' : 'app'}/hospitals/${
    portalOfficeData.id
  }`;

  const isCarelogood = listingInfo.portal_office?.is_carelogood === true;

  return {
    thumbnailInfo,
    portalOfficeInfo,
    isCarelogood,
    cardHref,
  };
};
